var _defs, _g, _g2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDeveloperPortalIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 181.039,
    height: 79.489,
    viewBox: "0 0 181.039 79.489",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n            .developerPortalA {\n                fill: #54b7e3;\n            }\n        "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(71.146)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "developerPortalA",
    d: "M20,60.676,32.221,48.408,20,36.142,18.655,37.5,29.526,48.408,18.655,59.322Z",
    transform: "translate(-0.991 -11.524)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "developerPortalA",
    width: 10.364,
    height: 1.913,
    transform: "translate(37.218 30.032)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "developerPortalA",
    width: 15.433,
    height: 1.913,
    transform: "translate(54.032 30.032)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "developerPortalA",
    width: 2.717,
    height: 1.913,
    transform: "translate(77.793 30.032)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "developerPortalA",
    width: 3.362,
    height: 1.913,
    transform: "translate(88.193 30.032)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "developerPortalA",
    width: 10.364,
    height: 1.913,
    transform: "translate(81.189 35.927)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "developerPortalA",
    width: 15.431,
    height: 1.913,
    transform: "translate(59.307 35.927)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "developerPortalA",
    width: 2.719,
    height: 1.913,
    transform: "translate(48.262 35.927)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "developerPortalA",
    width: 3.362,
    height: 1.913,
    transform: "translate(37.218 35.927)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "developerPortalA",
    width: 10.364,
    height: 1.913,
    transform: "translate(37.218 41.824)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "developerPortalA",
    width: 15.433,
    height: 1.913,
    transform: "translate(54.032 41.824)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "developerPortalA",
    width: 2.717,
    height: 1.913,
    transform: "translate(77.793 41.824)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "developerPortalA",
    width: 3.362,
    height: 1.913,
    transform: "translate(88.193 41.824)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "developerPortalA",
    width: 13.965,
    height: 1.913,
    transform: "translate(18.339 53.837)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "developerPortalA",
    width: 20.796,
    height: 1.913,
    transform: "translate(40.996 53.837)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "developerPortalA",
    width: 3.663,
    height: 1.913,
    transform: "translate(73.01 53.837)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "developerPortalA",
    width: 4.529,
    height: 1.913,
    transform: "translate(87.024 53.837)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "developerPortalA",
    width: 13.965,
    height: 1.913,
    transform: "translate(77.588 61.781)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "developerPortalA",
    width: 20.795,
    height: 1.913,
    transform: "translate(48.1 61.781)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "developerPortalA",
    width: 3.663,
    height: 1.913,
    transform: "translate(33.218 61.781)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "developerPortalA",
    width: 4.528,
    height: 1.913,
    transform: "translate(18.339 61.781)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "developerPortalA",
    width: 13.965,
    height: 1.913,
    transform: "translate(18.339 69.726)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "developerPortalA",
    width: 10.635,
    height: 1.913,
    transform: "translate(40.996 69.726)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "developerPortalA",
    width: 3.663,
    height: 1.913,
    transform: "translate(73.01 69.726)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "developerPortalA",
    width: 4.529,
    height: 1.913,
    transform: "translate(87.024 69.726)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "developerPortalA",
    d: "M107.691,16.843H11.7a6.974,6.974,0,0,0-6.952,6.98V89.352a6.974,6.974,0,0,0,6.952,6.98h95.989a6.974,6.974,0,0,0,6.952-6.98V23.823A6.975,6.975,0,0,0,107.691,16.843Zm5.046,72.509a5.062,5.062,0,0,1-5.046,5.067H11.7a5.062,5.062,0,0,1-5.046-5.067V36.376H112.738V89.352Zm0-54.89H6.655V23.823A5.062,5.062,0,0,1,11.7,18.756h95.989a5.062,5.062,0,0,1,5.046,5.067Z",
    transform: "translate(-4.751 -16.843)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "developerPortalA",
    d: "M10.974,27.311h22V22.687h-22ZM12.88,24.6H31.071v.8H12.88Z",
    transform: "translate(-3.068 -15.232)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "developerPortalA",
    d: "M82.88,21.559a3.75,3.75,0,1,0,3.735,3.75A3.746,3.746,0,0,0,82.88,21.559Zm0,5.587a1.837,1.837,0,1,1,1.829-1.837A1.835,1.835,0,0,1,82.88,27.146Z",
    transform: "translate(15.368 -15.543)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 8.929)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "developerPortalA",
    d: "M4.16,38.2l3.43.765a.125.125,0,0,1,.127.128A29.173,29.173,0,0,0,10.385,45.6v.128L8.479,48.787A2.7,2.7,0,0,0,8.86,52.1l4.192,4.209a2.688,2.688,0,0,0,3.3.383l3.049-1.913h.127a28.923,28.923,0,0,0,6.479,2.679.125.125,0,0,1,.127.128l.762,3.444A2.722,2.722,0,0,0,29.569,63.2H35.54a2.83,2.83,0,0,0,2.668-2.169l.762-3.444.127-.128a28.923,28.923,0,0,0,6.479-2.679l-.635-1.148.762,1.148L48.752,56.7a2.668,2.668,0,0,0,3.3-.383L56.248,52.1a2.716,2.716,0,0,0,.381-3.317l-1.906-3.061V45.6a29.173,29.173,0,0,0,2.668-6.506.125.125,0,0,1,.127-.128l3.43-.765a2.619,2.619,0,0,0,2.033-2.679V29.653a2.752,2.752,0,0,0-2.033-2.679l-3.557-.765-.127-.128A29.172,29.172,0,0,0,54.6,19.576v-.128L56.5,16.387a2.716,2.716,0,0,0-.381-3.317L51.928,8.861a2.688,2.688,0,0,0-3.3-.383l-3.049,1.913h-.127A28.923,28.923,0,0,0,38.97,7.713a.125.125,0,0,1-.127-.128l-.762-3.444A2.612,2.612,0,0,0,35.413,2.1H29.442a2.862,2.862,0,0,0-2.668,2.041l-.635,3.444a.125.125,0,0,1-.127.128,28.923,28.923,0,0,0-6.479,2.679l.635,1.148-.762-1.02L16.356,8.606a2.688,2.688,0,0,0-3.3.383L8.86,13.2a2.716,2.716,0,0,0-.381,3.317l1.906,3.061V19.7a29.172,29.172,0,0,0-2.668,6.506.125.125,0,0,1-.127.128L4.16,27.1A2.728,2.728,0,0,0,2,29.781v5.868A2.7,2.7,0,0,0,4.16,38.2Zm.381-8.547c0-.128,0-.128.127-.128L8.1,28.76a2.763,2.763,0,0,0,2.033-2.041,19.013,19.013,0,0,1,2.414-5.74,2.773,2.773,0,0,0,0-2.806l-1.906-3.061v-.255l4.192-4.209h.254l3.049,1.913a2.743,2.743,0,0,0,2.795,0,24.842,24.842,0,0,1,5.717-2.424A2.763,2.763,0,0,0,28.679,8.1l.762-3.444c0-.128,0-.128.127-.128H35.54c.127,0,.127,0,.127.128L36.429,8.1a2.817,2.817,0,0,0,1.906,2.041,18.854,18.854,0,0,1,5.717,2.424,2.743,2.743,0,0,0,2.795,0L49.9,10.647h.127l4.192,4.209v.255l-1.906,3.061a2.773,2.773,0,0,0,0,2.806,22.889,22.889,0,0,1,2.414,5.74,2.435,2.435,0,0,0,2.033,1.913l3.43.765a.125.125,0,0,1,.127.128v5.868c0,.128,0,.128-.127.128l-3.43.765A2.815,2.815,0,0,0,54.723,38.2a19.013,19.013,0,0,1-2.414,5.74,2.773,2.773,0,0,0,0,2.806l1.906,3.061v.255l-4.192,4.209h-.254L46.72,52.359a2.743,2.743,0,0,0-2.795,0,24.842,24.842,0,0,1-5.717,2.424A2.436,2.436,0,0,0,36.3,56.823l-.762,3.444a.125.125,0,0,1-.127.128H29.442a.125.125,0,0,1-.127-.128l-.762-3.444a2.763,2.763,0,0,0-2.033-2.041A18.854,18.854,0,0,1,20.8,52.359a2.743,2.743,0,0,0-2.795,0l-3.049,1.913h-.127l-4.192-4.209v-.255l1.906-3.061a2.773,2.773,0,0,0,0-2.806,22.889,22.889,0,0,1-2.414-5.74A2.435,2.435,0,0,0,8.1,36.286l-3.43-.765c-.127.128-.127.128-.127,0Z",
    transform: "translate(-2 -2.1)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "developerPortalA",
    d: "M29.624,46.786A17.093,17.093,0,1,0,12.6,29.693,17.06,17.06,0,0,0,29.624,46.786Zm0-31.635A14.542,14.542,0,1,1,15.141,29.693,14.506,14.506,0,0,1,29.624,15.151Z",
    transform: "translate(0.867 0.794)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "developerPortalA",
    d: "M23.656,34.863a1.259,1.259,0,0,0,1.652-.638l5.336-12.246a1.252,1.252,0,1,0-2.287-1.02L23.021,33.2A1.268,1.268,0,0,0,23.656,34.863Z",
    transform: "translate(3.659 2.895)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "developerPortalA",
    d: "M32.264,29.7,29.6,31.865a1.264,1.264,0,0,0,1.652,1.913l3.938-3.189a1.577,1.577,0,0,0,.508-1.02,1.162,1.162,0,0,0-.508-1.02l-3.938-3.189a1.346,1.346,0,0,0-1.779.128,1.541,1.541,0,0,0,.127,2.041Z",
    transform: "translate(5.341 4.235)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "developerPortalA",
    d: "M22.247,28.434a1.346,1.346,0,0,0,1.779-.128,1.36,1.36,0,0,0-.127-1.786L21.23,24.352,23.9,22.184a1.264,1.264,0,0,0-1.652-1.913l-3.938,3.189a1.577,1.577,0,0,0-.508,1.02,1.162,1.162,0,0,0,.508,1.02Z",
    transform: "translate(2.273 2.818)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeveloperPortalIcon);
export default __webpack_public_path__ + "static/media/developer-portal-icon.02bd6e56.svg";
export { ForwardRef as ReactComponent };